import React, { useEffect, useRef, useState } from 'react'
import { convertUnicode, createSafeHTML, fetchApi } from '../../../utils/methods'
import { DeleteInspirationPost } from '../../../redux/constants/apiConstants'
import PropTypes from 'prop-types'
import { AnnouncementContainer } from './style'
import { AdminLeftArrowIcon, DustbinIcon, WarningDelete, threeDot } from '../../../utils/icons'
import { DownAngleV2 } from '../styles'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { t } from 'i18next'
import CommonModal from '../../common/CommonModal/CommonModal'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'

const GlobalAnnouncement = ({ /*isGlobalAnnouncement,*/ globalAnnouncementData, getGlobalAnnouncementData}) => {

  //   const[globalAnnouncementData, setGlobalAnnouncementData] = useState([]);
  const [activeAnnouncement, setActiveAnnouncement]= useState({});
  const [activeAnnouncementIndex, setActiveAnnouncementIndex]= useState(0);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showFullText, setShowFullText] = useState([]);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, [activeAnnouncement]);


  useEffect(()=>{
    // getGlobalAnnouncementData()
    setActiveAnnouncement(globalAnnouncementData?.[0]);

  },[globalAnnouncementData])

  //   const getGlobalAnnouncementData = async()=>{
  //     const res = await fetchApi(GetSocialTipsAndQuotes + "/" + userCompanyId, "GET");
  //     // setGlobalAnnouncementData(res.data.announcements);
  //     setActiveAnnouncement(res.data.announcements[0]);
  //     setActiveAnnouncementIndex(0);
  //   }

  const setNextAnnouncement = () => {
    if (activeAnnouncementIndex + 1 < globalAnnouncementData.length) {
      setActiveAnnouncementIndex((prevIndex) => prevIndex + 1);
      setActiveAnnouncement(globalAnnouncementData[activeAnnouncementIndex + 1]);
    } else {
      setActiveAnnouncementIndex(0);
      setActiveAnnouncement(globalAnnouncementData[0]);
    }
  };
  
  const setPreviousAnnouncement = () => {
    if (activeAnnouncementIndex - 1 >= 0) {
      setActiveAnnouncementIndex((prevIndex) => prevIndex - 1);
      setActiveAnnouncement(globalAnnouncementData[activeAnnouncementIndex - 1]);
    } else {
      setActiveAnnouncementIndex(globalAnnouncementData.length - 1);
      setActiveAnnouncement(globalAnnouncementData[globalAnnouncementData.length - 1]);
    }
  };

  const deleteAnnouncement = async()=>{
    const res = await fetchApi(DeleteInspirationPost + "/" + activeAnnouncement.id, "DELETE");

    if(res?.status === "success"){
      setShowDeletePopup(false);
      getGlobalAnnouncementData();
    }else{
      toast.error(res?.data?.message)
    }

  }

  const handleCancel = ()=>{
    setShowDeletePopup(false);
  }

  const showFullTextFunction = (id) => {
    
    setShowFullText((prevState) =>
      prevState.includes(id)
        ? prevState.filter((itemId) => itemId !== id) // Remove ID (Show Less)
        : [...prevState, id] // Add ID (Show More)
    );
  };



  return (
    <>
      {globalAnnouncementData?.length > 0 ? <AnnouncementContainer background={activeAnnouncement?.banner_image_web} showMore={showFullText.includes(activeAnnouncement?.id)}>
        <div className='banner'>
          <span 
            ref={textRef}        
            className={`announcement-text ${
              showFullText.includes(activeAnnouncement?.id) ? "expanded" : "collapsed"
            }`}
          >{createSafeHTML(activeAnnouncement?.text ? convertUnicode(t(activeAnnouncement?.text)).split('\\n').join('<br />') : '')}</span>

          {isTruncated ? <div onClick={() => showFullTextFunction(activeAnnouncement?.id)} className='more-text'>{showFullText.includes(activeAnnouncement?.id) ? "Show less" : "Show more"}</div> : null}

        </div>



        {globalAnnouncementData?.length > 1 ? <div className='pagination'>
          <span className='prev-icon' onClick={()=>setPreviousAnnouncement()}><AdminLeftArrowIcon rotate="360"/></span><span className='active-announcement'>{activeAnnouncementIndex+1}/{globalAnnouncementData.length}</span><span className='nxt-icon' onClick={()=>setNextAnnouncement()}><AdminLeftArrowIcon rotate="180"/></span>
        </div> : null}

        {JSON.parse(localStorage.getItem('WELLNESS_ADMIN')) ? <div className='three-dots'>
          <DownAngleV2  feed>
            <DropdownButton id="editDelete" title={threeDot()}>
              <Dropdown.Item onClick={() =>{setShowDeletePopup(true)}}>
                {t("Delete")}
              </Dropdown.Item>
            </DropdownButton>
          </DownAngleV2>
        </div> : null}
      
      </AnnouncementContainer>:null}
      {showDeletePopup && 
      <CommonModal 
        show={showDeletePopup} 
        icon={WarningDelete()}
        title="Delete Announcement"
        description="Are you sure you want to delete this announcement?"
        subDescription={"This action cannot be undone, and the announcement will be permanently removed from the system."}
        onCancel={handleCancel}
        onConfirm={deleteAnnouncement}
        confirmButtonWidth={"182px"}
        cancelText="Keep"
        confirmButtonText="Delete Permanently"
        buttonIcon={DustbinIcon()}
        //modalHeight="184px"
      />}
    </>
  )
}

const mapStateToProps = (state) => ({
  isGlobalAnnouncement: state.social.isGlobalAnnouncement
})

GlobalAnnouncement.propTypes = {
  userCompanyId: PropTypes.object.isRequired,
  isGlobalAnnouncement:PropTypes.bool,
  globalAnnouncementData:PropTypes.array,
  getGlobalAnnouncementData:PropTypes.func
}

export default connect(mapStateToProps, null)(GlobalAnnouncement);
